import { useDIContext } from '@/Framework/DI/DIContext';
import ScorecardRepository from '@/finsight/infrastructure/repository/ScorecardRepository';
import createAsyncRequest from '@/Framework/State/createAsyncRequest';
import actionTypes from './actionTypes';
import createAction from '@/Framework/State/createAction';
import { ITtmFilter } from '@/finsight/application/League/interfaces';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';

interface IProps {
  page: number,
  perPage: number,
  selectedPeriod: ITtmFilter,
  searchText: string,
}

export default ({ page, perPage, selectedPeriod, searchText }:IProps, dispatch) => {
  const { container } = useDIContext();
  const scorecardRepository: ScorecardRepository = container.get(ScorecardRepository);
  const {
    includedRegionIds,
    includedProductIds,
  } = usePageFiltersContext();

  const getCompaniesAll = (payload) => {
    const method = () => scorecardRepository.getCompaniesAll(payload);
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_COLLECTION,
        actionTypes.GET_COLLECTION_SUCCESS,
        actionTypes.GET_COLLECTION_ERROR,
      ],
    });

    return request();
  };

  const paginateCompaniesAll = (payload) => dispatch(createAction(actionTypes.PAGINATE, payload));
  const itemsPerPageCompaniesAll = (payload) => dispatch(createAction(actionTypes.ITEMS_PER_PAGE, payload));
  const resetCompaniesAll = () => dispatch(createAction(actionTypes.RESET));
  const setCompaniesAllData = (payload) => dispatch(createAction(actionTypes.GET_COLLECTION_SUCCESS, payload));

  const getCompaniesAllByFilter = () => {
    const payload = {
      page,
      perPage,
      filters: {
        search: searchText || '',
        dateFrom: selectedPeriod.dateFrom,
        dateTo: selectedPeriod.dateTo,
        includedProductIds,
        includedRegionIds,
      },
    };

    getCompaniesAll(payload);
  };

  return {
    getCompaniesAllByFilter,
    paginateCompaniesAll,
    itemsPerPageCompaniesAll,
    resetCompaniesAll,
    setCompaniesAllData,
  };
};
